import { $ as e, C as t, F as n, H as r, J as i, L as a, O as o, R as s, S as c, U as l, _ as u, b as d, f, g as p, h as m, i as h, m as g, nt as _, ot as v, p as y, q as ee, rt as b, s as x, t as S, v as C, w } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as T, t as E } from "./i18n-lite-BcmwMblk.js";
import { t as D } from "./normalize-props-DNjMoRjC.js";
import { t as O } from "./Retry-Bb7MddeE.js";
//#region src/webcomponents/qcm-deepfake/locales/de-AT.json
var k = {}, A = {}, j = {}, M = {}, N = {}, P = { "qcm-deepfake": {
	options: {
		1: "une photo de sa chanteuse préférée",
		2: "une chanson de sa chanteuse préférée",
		3: "les partitions de la chanson",
		4: "une photo de Caroline",
		5: "un enregistrement de Caroline qui dit quelques phrases"
	},
	iaResultInfo: "Retrouvez ici les résultats du logiciel d'IA générative :",
	iaResultGenerated: "Résultat généré par le logiciel d'IA générative",
	in: "Entrée",
	out: "Sortie",
	waiting: "Logiciel d'IA générative",
	selectThreeElements: "Sélectionnez 3 éléments pour générer la vidéo de Caroline :",
	generateVideo: "Générer la vidéo !",
	loading: "Chargement…",
	restart: "Recommencer",
	element_one: "élément",
	element_other: "éléments",
	generateVideoInfo_one: "Plus que {{count}} élément",
	generateVideoInfo_other: "Plus que {{count}} éléments",
	restartInfo: "Essayez avec de nouveaux éléments",
	success: {
		title: "Bien joué !",
		description: "C'est bien la vidéo de Caroline. Vous avez utilisé les bons éléments."
	},
	fail: {
		title: "Pas exactement…",
		description: "Le résultat ne convient pas. Recommencez en changeant les éléments en entrée."
	}
} }, F = {}, I = {}, L = ["aria-hidden"], R = ["aria-level"], z = ["src"], B = {
	key: 1,
	class: "description"
}, V = ["src"], H = ["aria-level"], U = /*#__PURE__*/ S(/* @__PURE__ */ w({
	__name: "NarrativeAnswer.ce",
	props: {
		messageTitle: { type: String },
		messageDescription: { type: String },
		titleLevel: { type: Number },
		image: { type: String },
		title: { type: String },
		stateAnswer: { type: String },
		type: { type: String }
	},
	setup(e) {
		let { t } = T(), r = e, i = g(() => r.type === "success" || r.type === "fail" ? t("qcm-deepfake.out") : t("qcm-deepfake.waiting"));
		return (t, r) => (n(), C("div", {
			class: "right-container",
			"aria-hidden": e.type !== e.stateAnswer
		}, [
			m("div", {
				class: "subtitle",
				role: "heading",
				"aria-level": e.titleLevel
			}, v(i.value), 9, R),
			e.type === "search" ? (n(), C("img", {
				key: 0,
				src: e.image,
				alt: ""
			}, null, 8, z)) : u("", !0),
			e.type === "success" || e.type === "fail" ? (n(), C("p", B, v(e.title), 1)) : u("", !0),
			e.type === "search" ? u("", !0) : (n(), C("img", {
				key: 2,
				src: e.image,
				alt: ""
			}, null, 8, V)),
			e.messageTitle ? (n(), C("div", {
				key: 3,
				class: b(["answer-block", e.stateAnswer])
			}, [m("div", {
				class: "answer-block__title",
				role: "heading",
				"aria-level": e.titleLevel + 1
			}, v(e.messageTitle), 9, H), m("p", null, v(e.messageDescription), 1)], 2)) : u("", !0)
		], 8, L));
	}
}), [["styles", [".right-container[data-v-e4a7282e]{grid-area:1/1/1/1}.right-container[aria-hidden=true][data-v-e4a7282e]{visibility:hidden}img[data-v-e4a7282e]{margin-block:.5rem}.subtitle[data-v-e4a7282e]{text-align:center;font-size:1.25rem;font-weight:700}.description[data-v-e4a7282e]{margin-top:0;margin-bottom:0;font-weight:700}img[data-v-e4a7282e]{width:200px;height:auto}.answer-block[data-v-e4a7282e]{background:#e8e8e8;border-radius:10px;margin-inline:1rem;padding:.5rem}.answer-block p[data-v-e4a7282e]{margin-bottom:0}.answer-block.success[data-v-e4a7282e]{background:#e8f3ef}.answer-block.fail[data-v-e4a7282e]{background:#fbecec;border-radius:16px}"]], ["__scopeId", "data-v-e4a7282e"]]), W = ["aria-disabled"], G = /*#__PURE__*/ S(/* @__PURE__ */ w({
	__name: "Option.ce",
	props: /*@__PURE__*/ o({
		option: { type: String },
		value: { type: Number },
		readonly: { type: Boolean }
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t, { expose: a }) {
		let o = r(t, "modelValue"), s = e(!1), l = g(() => o.value.length === 3 && !s.value || t.readonly);
		function u(e) {
			if (l.value) {
				e.preventDefault();
				return;
			}
			e.target.checked ? o.value.push(t.option) : o.value = o.value.filter((e) => e !== t.option);
		}
		return a({ isChecked: s }), (e, r) => (n(), C("label", { class: b({
			selected: s.value,
			disabled: l.value
		}) }, [i(m("input", {
			"onUpdate:modelValue": r[0] ||= (e) => s.value = e,
			type: "checkbox",
			name: "options",
			"aria-disabled": l.value,
			onClick: u
		}, null, 8, W), [[x, s.value]]), c(v(t.option), 1)], 2));
	}
}), [["styles", [".selected[data-v-ce61a014]{background:#f7f5ff}.disabled[data-v-ce61a014]{cursor:not-allowed;background:#efefef}.disabled.selected[data-v-ce61a014]{background:#d6d5dd}"]], ["__scopeId", "data-v-ce61a014"]]), K = /*#__PURE__*/ S(/* @__PURE__ */ w({
	__name: "Button.ce",
	props: {
		label: { type: String },
		state: { type: String }
	},
	setup(e) {
		return (t, r) => (n(), C("button", { class: b(["epreuve-button", e.state]) }, [s(t.$slots, "icon"), c(" " + v(e.label), 1)], 2));
	}
}), [["styles", [".epreuve-button{--pix-neutral-0:#fff;--pix-neutral-800:#253858;--pix-neutral-900:#122647;--pix-secondary-500:#ffcb33;--pix-secondary-700:#a16206}.epreuve-button.primary{--background-color:var(--pix-neutral-800);--background-color-hover:var(--pix-neutral-900);--color:var(--pix-neutral-0);--color-hover:var(--pix-neutral-0)}.epreuve-button.warning{--background-color:var(--pix-secondary-500);--background-color-hover:var(--pix-secondary-700);--color:var(--pix-neutral-900);--color-hover:var(--pix-neutral-0)}.epreuve-button.primary,.epreuve-button.warning{background-color:var(--background-color);color:var(--color);cursor:pointer;white-space:nowrap;border:2px solid #0000;border-radius:8px;outline:none;justify-content:center;align-items:center;gap:8px;width:fit-content;margin:0 auto;padding:8px 24px;font-family:Roboto,sans-serif;font-size:1rem;font-weight:700;line-height:24px;transition:background-color .5s,color .5s;display:flex}:is(.epreuve-button.primary,.epreuve-button.warning)[aria-disabled=true]{cursor:not-allowed;opacity:.5}:is(.epreuve-button.primary,.epreuve-button.warning):not([aria-disabled=true]):hover{background-color:var(--background-color-hover);color:var(--color-hover);transition:background-color .5s,color .5s}:is(.epreuve-button.primary,.epreuve-button.warning):not([aria-disabled=true]):hover svg{color:var(--color-hover);transition:color .5s}:is(.epreuve-button.primary,.epreuve-button.warning):focus,:is(.epreuve-button.primary,.epreuve-button.warning):focus-visible{background-color:var(--background-color-hover);color:var(--color-hover);outline:1px solid var(--pix-neutral-0);outline-offset:-5px}"]]]), q = { class: "container" }, J = { class: "left-side" }, Y = ["aria-level"], X = { class: "sr-only" }, Z = { class: "left-side__action" }, Q = {
	key: 0,
	id: "optionsSelectedInfo",
	class: "left-side__lower-legend",
	"aria-hidden": "true"
}, te = {
	class: "right-side",
	"aria-live": "polite"
}, ne = /*#__PURE__*/ S(/* @__PURE__ */ w({
	__name: "QcmDeepfake.ce",
	props: {
		titleLevel: {
			default: 2,
			type: Number
		},
		successImage: { type: String },
		failImage: { type: String },
		infoImage: { type: String },
		searchImage: { type: String },
		searchDelay: {
			default: 3e3,
			type: Number
		}
	},
	setup(r, { expose: i }) {
		let { t: o } = T(), s = e([]), c = [
			2,
			4,
			5
		], h = e("info"), b = l("optionsNode"), x = [
			o("qcm-deepfake.options.1"),
			o("qcm-deepfake.options.2"),
			o("qcm-deepfake.options.3"),
			o("qcm-deepfake.options.4"),
			o("qcm-deepfake.options.5")
		], S = [
			"👩‍🎤",
			"🎧",
			"🎶",
			"👩",
			"🎙️"
		], w = x.map((e, t) => `${S[t]} ${e}`), E = w.filter((e, t) => c.includes(t + 1)), D = [
			{
				type: "info",
				image: r.infoImage
			},
			{
				type: "success",
				image: r.successImage,
				title: o("qcm-deepfake.iaResultGenerated"),
				messageTitle: `\uD83E\uDD73 ${o("qcm-deepfake.success.title")}`,
				messageDescription: o("qcm-deepfake.success.description")
			},
			{
				type: "fail",
				image: r.failImage,
				title: o("qcm-deepfake.iaResultGenerated"),
				messageTitle: `\uD83E\uDEE4 ${o("qcm-deepfake.fail.title")}`,
				messageDescription: o("qcm-deepfake.fail.description")
			},
			{
				type: "search",
				image: r.searchImage
			}
		], k = g(() => s.value.length !== 3 || h.value === "search"), A = g(() => h.value === "search" ? o("qcm-deepfake.loading") : h.value === "info" ? o("qcm-deepfake.generateVideo") : o("qcm-deepfake.restart")), j = g(() => h.value === "info" ? o("qcm-deepfake.generateVideoInfo", { count: c.length - s.value.length }) : h.value === "fail" ? o("qcm-deepfake.restartInfo") : "");
		function M() {
			return k.value ? !1 : h.value === "info" ? P() : N();
		}
		function N() {
			b.value.forEach((e) => {
				e.isChecked = !1;
			}), s.value = [], h.value = "info";
		}
		async function P() {
			let e = s.value.every((e) => E.includes(e.trim()));
			h.value = "search", await new Promise((e) => setTimeout(e, r.searchDelay)), e ? h.value = "success" : h.value = "fail";
		}
		return i({ reset: N }), (e, i) => (n(), C("div", q, [m("form", J, [
			m("div", {
				class: "left-side__subtitle",
				role: "heading",
				"aria-level": r.titleLevel
			}, v(e.$t("qcm-deepfake.in")), 9, Y),
			m("fieldset", null, [m("legend", X, v(e.$t("qcm-deepfake.selectThreeElements")), 1), (n(!0), C(y, null, a(_(w), (e, t) => (n(), p(G, {
				ref_for: !0,
				ref_key: "optionsNode",
				ref: b,
				key: t,
				modelValue: s.value,
				"onUpdate:modelValue": i[0] ||= (e) => s.value = e,
				class: "left-side__options",
				option: e,
				value: t + 1,
				readonly: h.value !== "info"
			}, null, 8, [
				"modelValue",
				"option",
				"value",
				"readonly"
			]))), 128))]),
			m("div", Z, [t(K, {
				"aria-disabled": k.value,
				label: A.value,
				state: h.value === "info" ? "primary" : "warning",
				"aria-describedby": ["success", "search"].includes(h.value) ? void 0 : "optionsSelectedInfo",
				onClick: f(M, ["prevent"])
			}, d({ _: 2 }, [h.value === "success" || h.value === "fail" ? {
				name: "icon",
				fn: ee(() => [t(O)]),
				key: "0"
			} : void 0]), 1032, [
				"aria-disabled",
				"label",
				"state",
				"aria-describedby"
			]), ["success", "search"].includes(h.value) ? u("", !0) : (n(), C("p", Q, v(j.value), 1))])
		]), m("div", te, [(n(), C(y, null, a(D, (e) => t(U, {
			key: e.type,
			"title-level": r.titleLevel,
			type: e.type,
			image: e.image,
			title: e.title,
			"message-title": e.messageTitle,
			"message-description": e.messageDescription,
			"state-answer": h.value
		}, null, 8, [
			"title-level",
			"type",
			"image",
			"title",
			"message-title",
			"message-description",
			"state-answer"
		])), 64))])]));
	}
}), [["styles", ["legend,label,p,div[role=heading]{color:#253858;font-family:Nunito,Roboto,sans-serif}", ".container[data-v-8bf77686]{gap:.8rem;display:flex}.title[data-v-8bf77686]{text-align:center;margin-bottom:16px;font-size:1.75rem;font-weight:700}.left-side[data-v-8bf77686]{background:#fff;border:1px solid #b0d3f4;border-radius:10px;min-width:60%;padding:.8rem}.left-side__lower-legend[data-v-8bf77686]{color:#5e6c84;font-size:.875rem}.left-side__subtitle[data-v-8bf77686]{text-align:center;font-size:1.25rem;font-weight:700}.left-side__options[data-v-8bf77686]{border:1px solid #5e6c84;border-radius:5px;gap:.5rem;padding:.6rem;display:flex}.left-side__button[data-v-8bf77686]{color:#000;cursor:pointer;background:#ffcb33;border:none;border-radius:25px;align-items:center;gap:.5rem;padding:.6rem 1.5rem;font-weight:700;display:flex}.left-side__button.generate[data-v-8bf77686]{color:#fff;background:#613fdd}.left-side__button[aria-disabled=true][data-v-8bf77686]{cursor:not-allowed;background:#d3d3d3}.left-side__action[data-v-8bf77686]{text-align:center;flex-direction:column;align-items:center;display:flex}.right-side[data-v-8bf77686]{text-align:center;background:#fff;border:1px solid #b0d3f4;border-radius:10px;padding:.8rem;display:grid}fieldset[data-v-8bf77686]{border:none;flex-direction:column;gap:.8rem;display:flex}.sr-only[data-v-8bf77686]{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}@media (width<=770px){.container[data-v-8bf77686]{flex-wrap:wrap}.left-side[data-v-8bf77686],.right-side[data-v-8bf77686]{width:100%}}"]], ["__scopeId", "data-v-8bf77686"]]);
//#endregion
//#region src/webcomponents/qcm-deepfake/qcm-deepfake.ce.js
E.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": k,
	"./locales/en.json": A,
	"./locales/es-419.json": j,
	"./locales/es.json": M,
	"./locales/fr-BE.json": N,
	"./locales/fr.json": P,
	"./locales/it.json": F,
	"./locales/nl.json": I
}));
var $ = h(ne, { configureApp(e) {
	E.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(E);
} });
$.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: D(e.titleLevel)
}), window.customElements.define("qcm-deepfake", $);
//#endregion
